export default {
  DepartmentCode: 'Mã phòng ban *',
  DepartmentName: 'Tên phòng ban *',
  Department: 'Thuộc phòng ban',
  DepartmentCodeWithOutStar: 'Mã phòng ban',
  DepartmentNameWithOutStar: 'Tên phòng ban',
  ValidateTreeChildren: 'Không được chọn phòng ban <span class="color-green">{0}</span> thuộc chính nó.',
  InvalidDepartment: 'Phòng ban không hợp lệ. Vui lòng kiểm tra lại.',
  DepartmentTitle: 'Phòng ban',
};
